var api = "https://api.qingcigame.com";
var obj = {
	index: function () {
        this.preloading();          // 预加载
        this.indexAjax();           // 首页数据
        // this.indexSwiper();         // 首页大轮播
        this.videoAndImg();         // 视频和图片预览
        this.indexBind();           // 首页按钮
        this.share();               // 分享链接
        // this.Textlength(28, 25);    // 内容字体长度超过40，标题字体长度超过25
        this.countNum();            //阿里云埋点
	},
    // 图片资源预加载
    preloading: function () {
        //图片预加载
        var queue = new createjs.LoadQueue();
        var _this = this;
        queue.on("progress", function (e) {
            //加载中的进度
            //加载中的进度
            if (e.progress * 100 >= 10) {
                $(".loding_time span").width(parseInt(e.progress * 100) + '%')
            };
            var numbers = e.progress * 100;
        }, this);
        queue.on("complete", function (e) {
            //加载完成执行操作
            $('.loding_time').remove();
            $('.preloading').addClass('preloading-ani').fadeOut(500);
            $('.index').addClass('index-show');
            _this.indexSwiper();
            // $('.recommend-popup').fadeIn();     // 新增加弹窗
            setTimeout(function() {
                $('.preloading').remove();

            },500)
        }, this);
        queue.loadManifest([
            //加载图片，不包括后台的            
            '//static.qcplay.com/snail/official/images/mobile/m_jdt.png',
            '//static.qcplay.com/snail/official/images/mobile/m_dt_t.png',
            '//static.qcplay.com/snail/official/images/mobile/m_dt_sz.png',
            '//static.qcplay.com/snail/official/images/mobile/index_content_title.png',
            '//static.qcplay.com/snail/official/images/mobile/index_content_bg_01.jpg',
            '//static.qcplay.com/snail/official/images/mobile/index_content_bg_02.jpg',
            '//static.qcplay.com/snail/official/images/mobile/index_content_bg_03.jpg',
            '//static.qcplay.com/snail/official/images/mobile/index_content_bg_04.jpg',
            '//static.qcplay.com/snail/official/images/mobile/index_content_bg_05.jpg',
            '//static.qcplay.com/snail/official/images/mobile/index_content_title_02.png',
            '//static.qcplay.com/snail/official/images/mobile/index_content_title_03.png',
            '//static.qcplay.com/snail/official/images/mobile/index_content_title_04.png',
            '//static.qcplay.com/snail/official/images/mobile/index_content_title_05.png',
            '//static.qcplay.com/snail/official/images/mobile/btn_and.png',
            '//static.qcplay.com/snail/official/images/mobile/btn_app.png',
            '//static.qcplay.com/snail/official/images/mobile/btn_more.png',
            '//static.qcplay.com/snail/official/images/mobile/header_bg_02.png',
            '//static.qcplay.com/snail/official/images/mobile/index_content_title_02.png',
            '//static.qcplay.com/snail/official/images/mobile/index_content_title_03.png',
            '//static.qcplay.com/snail/official/images/mobile/index_content_title_04.png',
            '//static.qcplay.com/snail/official/images/mobile/index_content_title_05.png',
            '//static.qcplay.com/snail/official/images/mobile/index_content_banner_02.png',
            '//static.qcplay.com/snail/official/images/mobile/index_content_banner_03.png',
            '//static.qcplay.com/snail/official/images/mobile/index_content_banner_04.png',
            '//static.qcplay.com/snail/official/images/mobile/btn_down.png',
        ]);
    },
    // 新闻列表
    newsList: function() {
        var cate_id, page, current, index, urls;
        // &limit=1
        urls = api + '/web/article'; // 第一页
        page = 1;
        this.hiddenNav();               // 头部隐藏导航
        this.newsZxList(urls, page);          // 新闻最新列表
        this.newsTabPage();             // 新闻导航切换
    },
    // 游戏攻略列表
    intrList: function() {
        var cate_id, page, current, index, urls;
        // &limit=1
        urls = api + '/web/article?page=1'; // 第一页
        this.hiddenNav();               // 头部隐藏导航
        this.newsIntrList(urls);        // 新闻最新列表
        this.newsTabPage();             // 新闻导航切换
    },
    // 新闻详情
    newsDetails: function() {
        this.hiddenNav();               // 头部隐藏导航
        this.newsInfo();                // 新闻详情
        this.footShare();               // 尾部分享
    },
    // 视频中心
    videoCenter: function() {
        this.hiddenNav();               // 头部隐藏导航
        this.videoSwitch();             // 新闻导航切换
        this.videoCenterAjax();         // 获取视频中心视频
    },
    // 视频详情
    videoDetails: function() {
        this.hiddenNav();               // 头部隐藏导航
        this.videoDetailsAjax();        // 获取详细的视频
        this.footShare();               // 尾部分享
    },
    // 同人专区
    colleagues: function() {
        this.hiddenNav();               // 头部隐藏导航
        this.worksAjax();               // 同人专区-作品
        this.videoSwitch();             // 全部、同人绘、手作
    },
    // 同人专区-作品详情
    drawingDetails: function() {
        this.hiddenNav();               // 头部隐藏导航
        this.drawingInfo();             // 获取数据
        this.footShare();               // 尾部分享
    },
    // wiki首页
    wikiIndex: function() {
        this.hiddenNav();               // 头部隐藏导航
        // this.wikiSwiper();              // 轮播
        this.wikiIndexAjax();
    },
    // wiki-贵重物品
    wikiPrecious: function() {
        var rarity, deviation, deviation, mosaic_skill, halo_effect, column, order, page, url;
        this.getWikiData();              // 获取筛选的参数
        this.wikibind();                // wiki绑定事件 
        this.filtering();               // wiki-贵重物品-筛选
        this.wikiearch();               // wiki-贵重物品-搜索
        this.wikiTabInfo();             // tab切换信息
        this.wikiPopup();               // 弹窗的开关查看详情
        this.preventInput();            // 阻止页面弹起
        this.hiddenNav();               // 头部隐藏导航
    },
    // 首页提示
    indexBind: function() {
        $('.title .play-btn, .role-info').click(function(event) {
            layer.msg("暂未开放，敬请期待!", {time: 2000});
        });

        $('.recommend-popup').on('click', '.close-btn', function(event) {
            $('.rec-box').addClass('hide-ani')
            $('.recommend-popup').fadeOut();
        });
    
        //适龄弹窗
        $('.year_box').on('click', function() {
            $('.year_pop').fadeIn();
        });
        $('.close-btn2').click(function(event) {
            $('.year_pop').fadeOut();
        });

        var Media = document.getElementById('media-play');
        $('.swiper-container-video').on('click', '.swiper-slide', function(event) {
            var data = $(this).attr('data');
            $('.popup').fadeIn().find('video').attr('src', data);
            Media.play();
        });

        $('.close-btn').click(function(event) {
            $('.popup').fadeOut().find('video').attr('src', '');
            Media.pause();
        });

        $('.download-btn').click(function(event) {
            var game_id = 39;
            $.ajax({
                type: "get",
                url: 'https://api.qingcigame.com/get_url?game_id='+game_id+'',
                dataType: 'json',
                xhrFields: {
                    withCredentials: true
                },
                success: function(json) {
                    // 微信
                    var ua = navigator.userAgent.toLowerCase();
                    if (ua.match(/MicroMessenger/i) == "micromessenger") {
                        $('.download_wrap').fadeIn();
                        return
                    };
                    //安卓
                    if (/(Android)/i.test(navigator.userAgent)) {
                        if (json.data.android_down_url == '') {
                            layer.msg('安卓下载暂未开放，敬请期待！<br/>详情请关注官方qq群：666341871', {time:3000});
                        } else {
                            // 安卓下载提示
                            $('.android_wrap').fadeIn();
                            location.href = json.data.android_down_url
                        }
                    };
                    //ios
                    if (/(iphone)/i.test(navigator.userAgent)) {
                        if (json.data.ios_down_url == '') {
                            layer.msg('ios下载暂未开放，敬请期待！<br/>详情请关注官方qq群：666341871', {time:3000});
                        } else {
                            location.href = json.data.ios_down_url
                        }
                    };
                }
            });
        });
        // 关闭下载提示
        $('.download_wrap').on('click', function () {
            $('.download_wrap').fadeOut();
        });

        // 关闭安卓下载提示
        $('.android_wrap').on('click', function () {
            $('.android_wrap').fadeOut();
        });

        $('.monitor-btn').on('click', function() {
            var data_event = $(this).attr('data-event');
            var data_url = $(this).attr('data-url');
            console.log(data_event)
            obj.countNum(data_event);
            if(data_url !== "") {
                setTimeout(() => {
                    location.href = data_url;
                }, 200);
            }
        })

        $('.monitor-btn-2').on('click', function() {
            var data_event = $(this).attr('data-event');
            console.log(data_event)
            obj.countNum(data_event);
        })
    },
    // 首页接口请求
    indexAjax: function() {
        var index = layer.load(2, {shade: [0.1, '#fff']});
        var _this = this;
        $.ajax({
            url: "https://api.qingcigame.com/web/index",
            type: "GET",
            xhrFields: {
                withCredentials: true
            },
            success: function(json) {
                var zonghe   = json.data.articleList.zonghe;
                var activity = json.data.articleList.activity;
                var cartoon  = json.data.articleList.cartoon;
                var jinjie   = json.data.articleList.jinjie;
                var mengxin  = json.data.articleList.mengxin;
                var video    = json.data.articleList.video;
                var jijie    = json.data.articleList.jijie;
                if(json.code == 200) {
                    // 综合新闻
                    $.each(zonghe, function(index, values) {
                        var zongheHtml = `<li>
                            <a href="news-details-mobile.html?id=${values.id}">
                                <h2>${values.article_title}</h2>
                                <p>${values.article_excerpt}</p>
                                <span>${values.created_at}</span>
                            </a>
                        </li>`;;
                        $('.zonghe').append(zongheHtml);
                    });

                    // 活动新闻
                    $.each(activity, function(index, values) {
                        var activityHtml = `<li>
                            <a href="news-details-mobile.html?id=${values.id}">
                                <h2>${values.article_title}</h2>
                                <p>${values.article_excerpt}</p>
                                <span>${values.created_at}</span>
                            </a>
                        </li>`;
                        $('.activity').append(activityHtml);
                    });

                    // 萌新入门
                    $.each(mengxin, function(index, values) {
                        var mengxinHtml = `<li>
                            <a href="news-details-mobile.html?id=${values.id}">
                                <h2>【${values.article_title}】${values.article_excerpt}</h2>
                                <p>作者：${values.origin}</p>
                            </a>
                        </li>`;
                        $('.mengxin').append(mengxinHtml);
                    });

                    // 进阶变强
                    $.each(jinjie, function(index, values) {
                        var jinjieHtml = `<li>
                            <a href="news-details-mobile.html?id=${values.id}">
                                <h2>【${values.article_title}】${values.article_excerpt}</h2>
                                <p>作者：${values.origin}</p>
                            </a>
                        </li>`;
                        $('.jinjie').append(jinjieHtml);
                    });

                    // 集结
                    // jijie
                    $.each(jijie, function(index, values) {
                        var jijieHtml = `<div class="other-inf">
                            <a href="drawing-details-mobile.html?article=${values.id}"><i></i></a>
                            <div class="banner">
                                <img src="${values.thumbnail}">
                            </div>
                            <div class="botton-inf">
                                <span>
                                    <h4>${values.origin}</h4>
                                    <p><b>${values.article_title}</b></p>
                                </span>
                            </div>
                        </div>`;
                        $('.other-wrap').append(jijieHtml);
                    });
                    

                    // 漫画3则  
                    // console.log(cartoon.length); 
                    // console.log(video); 
                    // console.log(cartoon[0].thumbnail);       
                    // if(cartoon.length >= 3)  {
                    //     $('.cartoon-ul .li-01').find('img').attr('src', cartoon[0].thumbnail).attr('data', cartoon[0].video_link);
                    //     $('.cartoon-ul .li-02').find('img').attr('src', cartoon[1].thumbnail).attr('data', cartoon[1].video_link);
                    //     $('.cartoon-ul .li-04').find('img').attr('src', cartoon[2].thumbnail).attr('data', cartoon[2].video_link);                        
                    // }   
                    // console.log(video[0]); 
                    // if(video.length !== 0)  {
                    //     // 视频添加
                    //     $('.cartoon-ul .li-01').find('img').attr('src',video[0].thumbnail).attr('data', video[0].video_link); 
                    //     $('.cartoon-ul .li-02').find('img').attr('src',video[1].thumbnail).attr('data', video[1].video_link); 
                    //     $('.cartoon-ul .li-03').find('img').attr('src',video[2].thumbnail).attr('data', video[2].video_link); 
                    //     $('.cartoon-ul .li-04').find('img').attr('src',video[3].thumbnail).attr('data', video[3].video_link);                       
                    // }
                    // 
                    $.each(video, function(index, values) {
                        var videoHtml = `<div class="swiper-slide" data="${values.video_link}"><a href="javascript:;"><img src="${values.thumbnail}"></a></div>`;
                        $('.swiper-container-video .slideTxtBox-box').append(videoHtml);
                    });
                    _this.indextabVideo();
                    _this.Textlength(28, 25);
                }else {
                    layer.msg("服务器请求失败", {time: 2000});
                }

            },error: function() {
                layer.msg("服务器请求失败", {time: 2000});
            },
            complete: function() {
                layer.close(index);
            }
        })

        $.ajax({
            url: "https://api.qingcigame.com/web/news/info",
            type: "GET",
            xhrFields: {
                withCredentials: true
            },
            success: function(json) {
                var article = json.data.article;
                if(json.code == 200) {
                    // 游戏资讯页-顶部
                    $('.content-02 .banner a, .content-06 .top-link a').remove();
                    $.each(article.game_information, function(index, values) {
                        var gameInfo = '<a href="'+ values.jump_url +'"><img src="'+ values.image +'"></a>';
                        $('.content-02 .banner').append(gameInfo);
                    });

                    // 同人专区页---公益活动
                    $.each(article.recommend, function(index, values) {
                        var artRecommend = '<a href="'+ values.jump_url +'" target="_blank"><img src="'+ values.image +'"></a>';
                        $('.content-06 .top-link').append(artRecommend);
                    });
                }else {
                    layer.msg("服务器请求失败", {time: 2000});
                }

            },error: function() {
                layer.msg("服务器请求失败", {time: 2000});
            },
            complete: function() {
                layer.close(index);
            }
        })
    },
	// 首页轮播
    indexSwiper: function() {
        function pageSwiper() {
            var mySwiper = new Swiper('.swiper-container', {
                pagination: '.swiper-pagination',
                direction: 'vertical',
                slidesPerView : 'auto',
                paginationClickable: true,
                spaceBetween: 0,
                mousewheelControl: true,
                resistanceRatio : 0,
                onInit: function(swiper){
                    swiperAnimate(swiper);
                }, 
                onSlideChangeEnd: function(swiper){ 
                    swiperAnimate(swiper);
                },
                onTouchEnd: function (swiper) {
                    swiperAnimate(swiper);
                },
            });
        }pageSwiper();

        function tabSwiperOne() { 
            var swiper2 = new Swiper('.swiper-container2', {
                pagination: '.swiper-pagination',
                paginationClickable: true,
                spaceBetween: 50,
                speed:300,
                onInit: function(swiper){
                    swiperAnimate(swiper);
                    function Ani (btn, page) {
                        $(btn).on('click', function(){
                            swiper2.slideTo(page-1, 300, true);
                        });
                    };
                    function navLink() {
                        for (var i = 2; i >= 1; i--) {
                            Ani('.tit-li-0'+i+'', i);
                        };
                    } navLink();
                }, 
                 onSlideChangeEnd: function(swiper){ 
                    swiperAnimate(swiper);
                    $('.tit-ul li').removeClass('on')
                    $('.tit-li-0'+Number(swiper.activeIndex+1)+'').addClass('on');
                },
                onTouchEnd: function (swiper) {
                  swiperAnimate(swiper);
                },
            });
        }tabSwiperOne();

        function tabSwiperTwo() {
            var swiper3 = new Swiper('.swiper-container3', {
                pagination: '.swiper-pagination',
                paginationClickable: true,
                spaceBetween: 50,
                speed:300,
                onInit: function(swiper){
                    swiperAnimate(swiper);
                    function Ani (btn, page) {
                        $(btn).on('click', function(){
                            swiper3.slideTo(page-1, 300, true);
                        });
                    };
                    function navLink() {
                        for (var i = 2; i >= 1; i--) {
                            Ani('.tit-li-0'+i+'', i);
                        };
                    } navLink();
                }, 
                 onSlideChangeEnd: function(swiper){ 
                    swiperAnimate(swiper);
                    $('.tit-ul li').removeClass('on')
                    $('.tit-li-0'+Number(swiper.activeIndex+1)+'').addClass('on');
                },
                onTouchEnd: function (swiper) {
                  swiperAnimate(swiper);
                },
            });
        }tabSwiperTwo();

        
    },
    indextabVideo() {
        function tabVideo() {
            var mySwiper = new Swiper('.swiper-container-video', {
                loop : true,
                pagination: '.swiper-pagination',
                effect: 'coverflow',
                grabCursor: true,
                centeredSlides: true,
                nextButton: '.swiper-button-next',
                prevButton: '.swiper-button-prev',
                slidesPerView: 'auto',
                coverflow: {
                    rotate: 0,// 旋转的角度
                    stretch: 12.3,// 拉伸   图片间左右的间距和密集度
                    depth:30,// 深度   切换图片间上下的间距和密集度
                    modifier: 10,// 修正值 该值越大前面的效果越明显
                    // slideShadows : false// 页面阴影效果
                }
            });
        }tabVideo()
    },
        // 内容字体长度超过40，标题字体长度超过25
    Textlength: function(x1, x2) {
        $('.slideTxtBox .bd p').each(function(){
            if($(this).text().length>x1){
                var str = $(this).text();
                $(this).text(str.substr(0,x1)+'...');
            }
        });
        $('.slideTxtBox .bd h2').each(function(){
            if($(this).text().length>x2){
                var str = $(this).text();
                $(this).text(str.substr(0,x2)+'...');
            }
        });
    },
    // 视频和图片预览
    videoAndImg: function() {

    },
    // 隐藏导航
    hiddenNav: function() {
        // 隐藏导航
        var change = true;
        $('.navBox').on('click','.nav_more',function () {
            if (change == true) {
                $('.nav_more').addClass('change');
                $('.nav-popup').addClass('nav-popup-show');
                change = false;
            } else {
                $('.nav_more').removeClass('change');
                $('.nav-popup').removeClass('nav-popup-show');
                change = true;
            }
            $('.screen-popup').fadeOut();
            $('.bottom-nav li').removeClass('on');
        });
    },
    // 获取当前hash的具体参数
    getQueryVariable: function(variable) {
        var query = window.location.href.split('?')[1];
        var vars = query.split("&");
        for (var i=0;i<vars.length;i++) {
            var pair = vars[i].split("=");
                if(pair[0] == variable){return pair[1];}
            }
        return(false);
    },
    // 最新、综合、活动跳转
    newsTabPage: function() {
        $('.all-list').on('click', 'li', function(event) {
            $(this).addClass('on').siblings('a').removeClass('on');
            var cate_id = $(this).attr('cate-id');
            window.location.href = window.location.href.split("?")[0]+'?cate_id='+cate_id+'&page=1'
        });
    },
    // 新闻列表接口
    newsZxList: function(urls) {
        cate_id = this.getQueryVariable('cate_id');
        page    = this.getQueryVariable('page');
        current = window.location.href.split("?")[0];
        index = layer.load(2, {shade: [0.1, '#fff']});
        $('.li-tab-0'+cate_id+'').addClass('on').siblings().removeClass('on');
        function newsAjax(urls) {
            console.log('urls------------', urls)
            $.ajax({
                url: urls,
                type: "GET",
                data: {
                    // cate_id 最新-综合-活动
                    // page    1...
                    cate_id: cate_id,
                    page: page,
                },
                xhrFields: {
                    withCredentials: true
                },
                success: function(json) {
                    if(json.code == 200) {
                        var current_page = json.data.articleList.current_page;  // 当前页数
                        var last_page = json.data.articleList.last_page;        // 总共页数
                        var next_page_url = json.data.articleList.next_page_url;// 后一页

                        // 渲染列表
                        $.each(json.data.articleList.data, function(index, values) {
                            var dtHtml = `<li>
                                    <a title="${values.article_title}" href="news-details-mobile.html?id=${values.id}">
                                        <h2>${values.article_title}</h2>
                                        <p>${values.article_excerpt}</p>
                                        <span>${values.created_at}</span>
                                    </a>
                                </li>`;
                            $('.list-wrap ul').append(dtHtml);
                        });
                        $('.current_page').html(current_page);      // 当前页数
                        $('.last_page').html(last_page);            // 总共页数
                        if(next_page_url === null) {                // 下一页
                            $('.more-btn a').attr('data', '').html('已经没有了'); // 没有最后一页
                        } else {
                            $('.more-btn a').attr('data', next_page_url).html('点击加载更多');;
                        }
                    }else {
                        layer.msg("服务器请求失败", {time: 2000});
                    }

                },error: function() {
                    layer.msg("服务器请求失败", {time: 2000});
                },
                complete: function() {
                    layer.close(index);
                }
            })            
        }
        newsAjax(urls);
        $('.more-btn').on('click', 'a', function(event) {
            if($(this).attr('data') == '') {
                layer.msg("已经没有了", {time: 2000});
            }else {
                page++
                urls = $(this).attr('data');
                newsAjax(urls);
                $('.more-btn a').html('正在加载中...');
            }            
        });
        for (var i = $('.link-box-02 div a').length; i >= 1; i--) {
            if(cate_id == i) $('.link-box-02 div a:nth-child('+i+')').addClass('on');
        };
    },
    // 新闻详情
    newsInfo: function() {
        var id = this.getQueryVariable('id');
        var index = layer.load(2, {shade: [0.1, '#fff']});
        $.ajax({
            url: "https://api.qingcigame.com/web/article/"+id+"",
            type: "GET",
            xhrFields: {
                withCredentials: true
            },
            success: function(json) {

                if(json.code == 200) {
                    var newsTitle = json.data.list.article_title;       // 标题
                    var detailsInfo = json.data.list.article_content;   // 内容
                    var origin      = json.data.list.origin;            // 作者
                    var created_at      = json.data.list.created_at;    // 时间
                    $('.news-title, .current-title').html(newsTitle);
                    $('.details-info').append(detailsInfo);
                    $('.origin').html(origin);
                    $('.created_at').html(created_at);
                    // 翻页功能
                    obj.pageDown(json.data.last, json.data.next, 'id');
                }else {
                    layer.msg("服务器请求失败", {time: 2000});
                }

            },error: function() {
                layer.msg("服务器请求失败", {time: 2000});
            },
            complete: function() {
                layer.close(index);
            }
        })
    },
    // 翻页功能
    pageDown: function(lastPage, nextPage, cite) {
        var href = window.location.href.split("?")[0] + '?'+cite+'='
        // console.log(href)
        // console.log(lastPage);
        // console.log(nextPage);

        if(lastPage !== '') $('.prev-page').addClass('show').attr('href', href+lastPage.id).attr('title', lastPage.article_title);
        if(nextPage !== '') $('.next-page').addClass('show').attr('href', href+nextPage.id).attr('title', nextPage.article_title);
    },
    // 视频切换
    videoSwitch: function() {
       $('.all-list').on('click', 'li', function(event) {
            $(this).addClass('on').siblings('a').removeClass('on');
            var cate_id = $(this).attr('cate-id');
            window.location.href = window.location.href.split("?")[0]+'?id='+cate_id
        });
    },
    // 新闻列表接口
    newsIntrList: function(urls) {
        cate_id = this.getQueryVariable('cate_id');
        page    = this.getQueryVariable('page');
        current = window.location.href.split("?")[0];
        index = layer.load(2, {shade: [0.1, '#fff']});
        $('.li-tab-0'+cate_id+'').addClass('on').siblings().removeClass('on');
        function newsAjax() {
            console.log('urls-----------', urls)
            $.ajax({
                url: urls,
                type: "GET",
                data: {
                    // cate_id 最新-综合-活动
                    // page    1...
                    cate_id: cate_id,
                    page: page,
                },
                xhrFields: {
                    withCredentials: true
                },
                success: function(json) {
                    if(json.code == 200) {
                        var current_page = json.data.articleList.current_page;  // 当前页数
                        var last_page = json.data.articleList.last_page;        // 总共页数
                        var next_page_url = json.data.articleList.next_page_url;// 后一页
                        // 渲染列表
                        $.each(json.data.articleList.data, function(index, values) {
                            var dtHtml = `<li>
                                    <a title="${values.article_title}" href="wiki-details-mobile.html?id=${values.id}">
                                        <h2>${values.article_title}</h2>
                                        <p>${values.article_excerpt}</p>
                                        <span>${values.created_at}</span>
                                    </a>
                                </li>`;
                            $('.list-wrap ul').append(dtHtml);
                        });
                        $('.current_page').html(current_page);      // 当前页数
                        $('.last_page').html(last_page);            // 总共页数
                        if(next_page_url === null) {                // 下一页
                            $('.more-btn a').attr('data', '').html('已经没有了'); // 没有最后一页
                        } else {
                            $('.more-btn a').attr('data', next_page_url);
                        }
                    }else {
                        layer.msg("服务器请求失败", {time: 2000});
                    }

                },error: function() {
                    layer.msg("服务器请求失败", {time: 2000});
                },
                complete: function() {
                    layer.close(index);
                }
            })            
        }
        newsAjax(urls);
        $('.more-btn').on('click', 'a', function(event) {
            if($(this).attr('data') == '') {
                layer.msg("已经没有了", {time: 2000});
            }else {
                urls = $(this).attr('data');
                newsAjax(urls);
            }            
        });

        // 导航变色
        if(cate_id == 1) $('.link-box-03 div a:nth-child(1)').addClass('on');
        if(cate_id == 9) $('.link-box-03 div a:nth-child(2)').addClass('on');
        if(cate_id == 19) $('.link-box-03 div a:nth-child(4)').addClass('on');
    },
    // 获取视频中心视频
    videoCenterAjax: function() {
        var id = this.getQueryVariable('id');        
        var index = layer.load(2, {shade: [0.1, '#fff']});
        $('.li-tab-0'+id+'').addClass('on').siblings().removeClass('on');
        
        // 全部视频
        $.ajax({
            url: "https://api.qingcigame.com/web/article?cate_id="+id+"&limit=0",
            type: "GET",
            xhrFields: {
                withCredentials: true
            },
            success: function(json) {
                if(json.code == 200) {
                    if(id == 13) {
                        // 渲染漫画
                        $.each(json.data.articleList, function(index, values) {
                            var dtHtml = `<li><a href="cartoon-details-mobile.html?id=${values.id}">${values.article_title}</a></li>`;
                            $('.cartoon-list ul').append(dtHtml);
                        });
                    } else {
                        // 渲染视频数量
                        $.each(json.data.articleList, function(index, values) {
                            var dtHtml = `<li>
                                <dl>
                                    <dt>
                                        <a href="video-details-mobile.html?id=${values.id}"><img src="${values.thumbnail}"></a>
                                    </dt>
                                    <dd>${values.article_title}</dd>
                                </dl>
                            </li>`;
                            $('.video-list ul').append(dtHtml);
                        });
                    }
                    $('.s-title span').html('（连载至第'+parseInt(json.data.articleList.length)+'话）');
                }else {
                    layer.msg("服务器请求失败", {time: 2000});
                }

            },error: function() {
                layer.msg("服务器请求失败", {time: 2000});
            },
            complete: function() {
                layer.close(index);
            }
        })

        for (var i = $('.link-box-04 div a').length; i >= 1; i--) {
            if(id == 1+''+i+'') $('.link-box-04 div a:nth-child('+i+')').addClass('on');
        };
    },
    // 获取详细视频
    videoDetailsAjax: function() {
        var id = this.getQueryVariable('id');
        var index = layer.load(2, {shade: [0.1, '#fff']});
        $.ajax({
            url: "https://api.qingcigame.com/web/article/"+id+"",
            type: "GET",
            xhrFields: {
                withCredentials: true
            },
            success: function(json) {

                if(json.code == 200) {
                    var newsTitle = json.data.list.article_title;       // 标题
                    var detailsInfo = json.data.list.article_content;   // 内容
                    var origin      = json.data.list.origin;            // 作者
                    var created_at      = json.data.list.created_at;    // 时间
                    var video_link      = json.data.list.video_link;    // 视频
                    $('.news-title, .current-title').html(newsTitle);
                    $('.details-info').append(detailsInfo);
                    $('.origin').html(origin);
                    $('.created_at').html(created_at);
                    $('.details-info video').attr('src', video_link);
                    // 翻页功能
                    obj.pageDown(json.data.last, json.data.next, 'id');
                }else {
                    layer.msg("服务器请求失败", {time: 2000});
                }

            },error: function() {
                layer.msg("服务器请求失败", {time: 2000});
            },
            complete: function() {
                layer.close(index);
            }
        })
    },
    // 同人区
    worksAjax: function() {
        var id = this.getQueryVariable('id');
        $('.li-tab-0'+id+'').addClass('on').siblings().removeClass('on');
        
        var index = layer.load(2, {shade: [0.1, '#fff']});
        $.ajax({
            url: "https://api.qingcigame.com/web/article?cate_id="+id+"",
            type: "GET",
            xhrFields: {
                withCredentials: true
            },
            success: function(json) {
                if(json.code == 200) {
                    $.each(json.data.articleList.data, function(index, values) {
                        var dtHtml = `<li class="article">
                            <a href="drawing-details-mobile.html?article=${values.id}">
                                <img src="${values.thumbnail}">
                            </a>
                            <div class="pic_info" >
                                <div class="txt_info">
                                    <p class="pic_name" title="${values.article_title}">${values.article_title}</p>
                                    <div class="author_name">
                                        <span>${values.origin}</span>
                                    </div>
                                </div>
                                <div class="hot_level">
                                    <em></em>
                                    <span>${values.like_num}</span>
                                </div>
                            </div>
                        </li>`;
                        // 渲染后 瀑布流
                        $('.wall').append(dtHtml).jaliswall({ item: '.article' });
                        $('.pager-more').fadeIn();
                    });
                }else {
                    layer.msg("服务器请求失败", {time: 2000});
                }

            },error: function() {
                layer.msg("服务器请求失败", {time: 2000});
            },
            complete: function() {
                layer.close(index);
            }
        })

        if(id == 15) $('.link-box-05 div a:nth-child(1)').addClass('on');
        if(id == 16) $('.link-box-05 div a:nth-child(2)').addClass('on');
    },
    // 同人专区-作品详情
    drawingInfo: function() {
        var article = this.getQueryVariable('article');
        var index = layer.load(2, {shade: [0.1, '#fff']});
        $.ajax({
            url: "https://api.qingcigame.com/web/article/"+article+"",
            type: "GET",
            xhrFields: {
                withCredentials: true
            },
            success: function(json) {
                if(json.code == 200) {
                    var newsTitle   = json.data.list.article_title;     // 标题
                    var detailsInfo = json.data.list.article_content;   // 内容
                    var origin      = json.data.list.origin;            // 作者
                    var created_at  = json.data.list.created_at;        // 时间
                    var like_num    = json.data.list.like_num;          // 点赞
                    var video_link  = json.data.list.video_link;        // 视频

                    // 如果内容是空则为视频-否则默认新闻输出
                    if(detailsInfo == '') {
                        $('.details-info div').append('<video controls="controls" controlslist="nodownload" src="'+video_link+'" width="100%" height="100%" disablepictureinpicture="true" autoplay="autoplay" style="background-color: black;"></video>');
                    }
                    // 图片或者视频输出
                    $('.details-info div').append(detailsInfo);
                    $('.details-info').fadeIn();
                    $('.news-title, .current-title').html(newsTitle);
                    $('.origin').html(origin);
                    $('.created_at').html(created_at);
                    $('.btnVote').html(like_num);
                    // 翻页功能
                    obj.pageDown(json.data.last, json.data.next, 'article');
                }else {
                    layer.msg("服务器请求失败", {time: 2000});
                }

            },error: function() {
                layer.msg("服务器请求失败", {time: 2000});
            },
            complete: function() {
                layer.close(index);
            }
        })

        // 点赞
        $('.btnVote').click(function(event) {
            $.ajax({
                url: "https://api.qingcigame.com/web/article/?id="+article+"",
                type: "POST",
                xhrFields: {
                    withCredentials: true
                },
                success: function(json) {
                    if(json.code == 200) {
                        $('.alert_box').fadeIn();
                        var number = Number($('.btnVote').html())+1;
                        $('.btnVote').html(number)
                    }else {
                        layer.msg("服务器请求失败", {time: 2000});
                    }

                },error: function() {
                    layer.msg("服务器请求失败", {time: 2000});
                },
                complete: function() {
                    layer.close(index);
                }
            })
        });

        // 关闭点赞提示框
        $('.alert_box .alertClose, .alert_box .btnsConfirm').click(function(event) {
            $('.alert_box').fadeOut();
        });
    },
    // wiki轮播
    wikiSwiper: function() {
        var swiper2 = new Swiper('.swiper-container2', {
            pagination: '.swiper-pagination',
            paginationClickable: true,
            spaceBetween: 50,
            speed:300,
        });
    },
    wikiIndexAjax: function() {
        var index = layer.load(2, {shade: [0.1, '#fff']});
        var _this = this;
        $.ajax({
            url: "https://api.qingcigame.com/web/getdata",
            type: "GET",
            xhrFields: {
                withCredentials: true
            },
            success: function(json) {
                var banner = json.data.articleList.banner;              // 地图探索     
                var ditu = json.data.articleList.ditu;              // 地图探索                
                var hot  = json.data.articleList.hot;               // 热门
                var xinshou= json.data.articleList.xinshou.data;    // 新手
                var xingtai= json.data.articleList.xingtai;         // 形态
                var index  = json.data.articleList.index;               // 热门
                if(json.code == 200) {

                    // // 渲染-地图探索
                    $.each(banner, function(index, values) {
                        var addHtml = `<div class="swiper-slide">
                            <a href="${values.url}">
                                <img src="${values.mobile_background}">
                            </a>
                        </div>`;
                        $('.swiper-container2 .swiper-wrapper').append(addHtml);
                    });
                    _this.wikiSwiper();
                    $('.swiper-container2 .swiper-slide:nth-child(1)').find('a').attr('href','introduction-list-mobile.html?cate_id=9&page=1');
                    $('.swiper-container2 .swiper-slide:nth-child(2)').find('a').attr('href','wiki-precious-mobile.html');
                    $('.swiper-container2 .swiper-slide:nth-child(3)').find('a').attr('href','introduction-list-mobile.html?cate_id=17&page=1');
                    
                    // // 渲染-地图探索
                    $.each(ditu, function(index, values) {
                        var addHtml = `<li><a href="wiki-details-mobile.html?id=${values.id}"><img src="${values.thumbnail}"><span></span></a></li>`;
                        $('.map-exploration ul').prepend(addHtml);
                    });

                    $('.map-exploration li:nth-child(1)').find('span').html('高丽');
                    $('.map-exploration li:nth-child(2)').find('span').html('扶桑');
                    $('.map-exploration li:nth-child(3)').find('span').html('华夏');
                    $('.map-exploration li:nth-child(4)').find('span').html('米国');
                    $('.map-exploration li:nth-child(5)').find('span').html('英伦');

                    // // 渲染-热门
                    $.each(hot, function(index, values) {
                        var addHtml = `<li><a href="wiki-details-mobile.html?id=${values.id}">${values.article_title}</a></li>`;
                        $('.hot-pages .list ul').append(addHtml);
                    });
                    // // 新手指南
                    for (var i = $('.novice-guide li').length-1; i >= 0; i--) {
                        // console.log(xinshou[i].id)
                        $('.novice-guide .li-0'+i+' a').attr('href','wiki-details-mobile.html?id='+xinshou[i].id+'');
                    };

                    $('.novice-guide .li-04 a').attr('href', 'introduction-list-mobile.html?cate_id=9&page=1');

                    // // 渲染-形态
                    $.each(xingtai, function(index, values) {
                        var addHtml = `<li><a href="wiki-details-mobile.html?id=${values.id}"><img src="${values.thumbnail}"><span>${values.cate_id}</span></a></li>`;
                        $('.form-intr ul').prepend(addHtml);
                    });

                    // 先固定写死
                    $('.form-intr ul li:nth-child(1)').find('span').html('活尸');
                    $('.form-intr ul li:nth-child(2)').find('span').html('恶魔');
                    $('.form-intr ul li:nth-child(3)').find('span').html('天使');
                    $('.form-intr ul li:nth-child(4)').find('span').html('机械');
                    $('.form-intr ul li:nth-child(5)').find('span').html('异种');
                    $('.form-intr ul li:nth-child(6)').find('span').html('巨龙');
                }else {
                    layer.msg("服务器请求失败", {time: 2000});
                }
            },error: function() {
                layer.msg("服务器请求失败", {time: 2000});                
            },
            complete: function() {
                layer.close(index);
            }
        })
    },
    // 获取需要筛选的wiki参数
    getWikiData: function() {
        var index = layer.load(2, {shade: [0.1, '#fff']});
        $.ajax({
            url: "https://api.qingcigame.com/web/get_type",
            type: "GET",
            xhrFields: {
                withCredentials: true
            },
            success: function(json) {
                if(json.code == 200) {
                    // 渲染-wiki-光环技能的参数
                    $.each(json.data.data.halo_effect, function(index, values) {
                        var addHtml = `<li data="${values}">${values}</li>`;
                        $('.halo_effect').append(addHtml);
                    });

                    // 渲染-wiki-镶嵌技能的参数
                    $.each(json.data.data.mosaic_skill, function(index, values) {
                        var addHtml = `<li data="${values}">${values}</li>`;
                        $('.mosaic_skill').append(addHtml);
                    });
                    $('.halo_effect, .mosaic_skill').find('li:nth-child(1)').addClass('on').attr('data', '');
                }else {
                    layer.msg("服务器请求失败", {time: 2000});
                }

            },error: function() {
                layer.msg("服务器请求失败", {time: 2000});
            },
            complete: function() {
                layer.close(index);
            }
        })
    },
    wikibind: function() {
        $('.bottom-nav').on('click', 'li', function(event) {
            $(this).addClass('on').siblings().removeClass('on');
            $(this).attr('data');
            $('.screen-popup').fadeIn().find('.'+$(this).attr('data')+'').fadeIn().siblings('.screen-wrap').hide();
            $('.nav_more').removeClass('change');
                $('.nav-popup').removeClass('nav-popup-show');
                change = true;
            });
    },
    // 信息切换-关闭弹窗清除数据
    wikiTabInfo: function() {
        $('.info-box .tit').on('click', 'h4', function(event) {
            $(this).addClass('on').siblings().removeClass('on').parent('.tit').siblings('.con').children('div').eq($(this).index()).addClass('show').siblings().removeClass('show');
        }); 
    },
    // 贵重物品弹窗
    wikiPopup: function() {
        // 开启弹窗
        $('.goods-list-wrap').on('click', 'li', function(event) {
            $('.wiki-popup').fadeIn();
            var title        = $(this).attr('titles');       // 标题
            var colour      = $(this).attr('colour');        // 颜色
            var art         = $(this).attr('art');           // 艺术
            var culture     = $(this).attr('culture');       // 文化
            var describe    = $(this).attr('describe');      // 简介
            var deviation   = $(this).attr('deviation');     // 偏向
            var faith       = $(this).attr('faith');         // 信仰
            var get_type    = $(this).attr('get_type');      // 获取途径  
            var halo_effect = $(this).attr('halo_effect');   // 光环技能
            var id          = $(this).attr('id');            // 图片id
            var mosaic_skill= $(this).attr('mosaic_skill');  // 镶嵌技能
            var popularity  = $(this).attr('popularity');    // 人气
            var quality     = $(this).attr('quality');
            var rarity      = $(this).attr('rarity');
            var rarity_order= $(this).attr('rarity_order');
            var technology  = $(this).attr('technology');    // 科技

            if(rarity == '无') rarity = ''                   // 无不输出

            $('.wiki-wrap h1').html(title);                 // 标题
            $('.wiki-wrap .span-pj').html(quality+rarity);  // 颜色
            $('.wiki-wrap .span-px').html(deviation);       // 偏向

            $('.wiki-wrap .pic-img img').attr('src', 'https://download4.qcplay.com/qcgame-admin/snailValuables/'+id+'.png')
            $('.wiki-wrap .pic-img').addClass('pic-img-0'+colour+'');   // 框框颜色

            if(halo_effect == '')  halo_effect = '暂无数据'
            if(mosaic_skill == '') mosaic_skill = '暂无数据'
            if(get_type == '') get_type = '暂无数据'
            if(describe == '') describe = '暂无数据'
            $('.wiki-wrap .p-01').html(halo_effect);         // 光环技能
            $('.wiki-wrap .p-02').html(mosaic_skill);        // 镶嵌技能
            $('.wiki-wrap .p-03').html(get_type);            // 镶嵌技能
            $('.wiki-wrap .p-04').html(describe);            // 简介

            $('.wiki-wrap .data-ul .li-01').html(popularity);// 人气
            $('.wiki-wrap .data-ul .li-02').html(art);       // 艺术
            $('.wiki-wrap .data-ul .li-03').html(faith);     // 信仰
            $('.wiki-wrap .data-ul .li-04').html(culture);   // 文化
            $('.wiki-wrap .data-ul .li-05').html(technology);// 科技

            if(colour == 1) colour ='#f9ab61'
            if(colour == 2) colour ='#81c9d4'
            if(colour == 3) colour ='#9cbd56'
            if(colour == 4) colour ='#DCA8C7'
            myChart(popularity,art,faith,culture,technology,colour);
        });
        
        // 关闭弹窗
        $('.wiki-popup').on('click', '.close-btn', function(event) {
            $('.wiki-popup').fadeOut();
            setTimeout(function() {
                for (var i = 4; i >= 0; i--) $('.wiki-wrap .pic-img').removeClass('pic-img-0'+i+''); // 框框颜色
                $('.wiki-wrap .pic-img img').attr('src', '');
                $('.wiki-wrap h1, .wiki-wrap h2 span').html('');    // 清空标题/颜色
                $('.wiki-wrap .con p').html('');                    // 清空光环技能/镶嵌技能/镶嵌技能/简介
                $('.wiki-wrap .data-ul li').html('');               // 清空/人气/艺术/信仰/文化/科技
                $('.wiki-wrap .tit .h4-01').addClass('on').siblings().removeClass('on');              // tab恢复
                $('.wiki-wrap .con div:nth-child(1)').addClass('show').siblings().removeClass('show');// tab恢复
            }, 300)
        });

        function myChart(popularity,art,faith,culture,technology,colour) {
            // console.log(colour)
            //指定图表的配置项和数据
            option = {
                //标题    
                // title: {
                //     text: '贵重物品五维图'
                // },
                tooltip: {},
                radar: {
                    center: ['50%', '60%'],
                    startAngle: 90,
                    name: {
                        formatter: '{value}',
                        textStyle: {
                            color: '#937f80',
                            fontSize: '8',
                            lineHeight: 8,
                            padding: [0, 0],
                        },
                        formatter:function(data, indicator){
                            let data0 = data.substring(0, 2)
                            let data1 = data.substring(2)       
                            if (data1 == maxData) indicator.nameTextStyle.color = colour     
                            return data0 + '\n' + data1
                            // return val.split(":").join("\n");
                        },
                    },
                    // 指示器名称和指示器轴的距离。[ default: 5 ]
                    nameGap: 5,
                    // 雷达图圈数设置
                    splitNumber: 2,  
                    // 设置雷达图中间射线的颜色
                    axisLine: {
                        lineStyle: {
                            width : 2,
                            color: '#ae988b',
                        },
                    },
                    splitArea : {
                        show : true ,
                        areaStyle : {
                            color: '#EDDCC4', // 图表背景的颜色
                        },
                    },
                    splitLine : {
                        show : true ,
                        lineStyle : {
                            width : 2,
                            color : '#ac998b', // 设置网格的颜色
                        },
                    },
                    indicator: [
                       { name: '人气'+popularity, max: 120},
                       { name: '科技'+technology, max: 120},
                       { name: '文化'+culture, max: 120},
                       { name: '信仰'+faith, max: 120},
                       { name: '艺术'+art, max: 120},
                    ],
                    radius: 41
                },
                series: [{
                    type: 'radar',
                     itemStyle: { // 折线拐点标志的样式。
                        normal: { // 普通状态时的样式
                            lineStyle: {
                                width: 2,
                                color: colour,
                            },                              
                        },
                    },
                    data : [
                        {
                            value : [popularity, technology, culture, faith, art],
                            itemStyle: { // 单个拐点标志的样式设置。
                                normal: {
                                    color: 'rgba(60,135,213,.3)',
                                    opacity: 0.2,
                                    // 拐点的描边颜色。[ default: '#000' ]
                                    borderWidth: 1,
                                    // 拐点的描边宽度，默认不描边。[ default: 0 ]
                                }
                            },
                            areaStyle: {
                                normal: {
                                    color: colour // 选择区域颜色
                                }
                            }

                        },
                    ],
                }]
            };
            var maxData = Math.max.apply(this, option.series[0].data[0].value)
            //获取dom容器
            var myChart = echarts.init(document.getElementById('chartmain'));
            // 使用刚指定的配置项和数据显示图表。
            myChart.setOption(option);
        }
    },
    // wiki-贵重物品-搜索
    wikiearch: function() {
        var _this = this;
        $('.search-btn').on('click', function(event) {
            var searchIpu =  $('.search-input').val()
            if(searchIpu == '') {
                layer.msg("请输入您需要搜索的名称", {time: 2000});
                return
            }
            var index = layer.load(2, {shade: [0.1, '#fff']});
            $.ajax({
                url: api + '/web/goods',
                type: "GET",
                data: {
                    title: searchIpu
                },
                xhrFields: {
                    withCredentials: true
                },
                success: function(json) {
                    if(json.code == 200) {
                        var next_page_url = json.data.data.next_page_url;   // 下一页的数据
                        // 如果下页有参数则显示更多按钮
                        next_page_url !== null ? $('.more-wrap').fadeIn().attr('data', next_page_url) : $('.more-wrap').hide();

                        $('.search-input').val('')  // 搜索完成后搜索栏目清空
                        // 清除信息
                        var gradeSet = resetSet('.grade');
                        var dimensionSet = resetSet('.dimension');
                        var halo_effectSet = resetSet('.halo_effect');
                        var mosaic_skillSet = resetSet('.mosaic_skill');
                        var grade_arraySet = resetSet('.grade_array');
                        function resetSet(li) {
                            $(li).find('li').removeClass('on');
                        }

                        $('.goods-list-wrap ul').find('li').remove();
                        if (json.data.data.data == '') {
                            layer.msg("未能找到相应贵重品", {time: 2000});
                            $('.tips-wrap').fadeIn();
                        } else {
                            $.each(json.data.data.data, function(index, values) {
                                var addHtml = `<li class="li-color-0${values.colour}" 
                                titles="${values.title}"
                                colour="${values.colour}" 
                                art="${values.art}" 
                                culture="${values.culture}" 
                                describe="${values.describe}" 
                                deviation="${values.deviation}" 
                                faith="${values.faith}" 
                                get_type="${values.get_type}" 
                                halo_effect="${values.halo_effect}" 
                                id="${values.id}" 
                                mosaic_skill="${values.mosaic_skill}" 
                                popularity="${values.popularity}" 
                                quality="${values.quality}" 
                                rarity="${values.rarity}" 
                                rarity_order="${values.rarity_order}" 
                                technology="${values.technology}">
                                    <div>
                                        <img src="https://download4.qcplay.com/qcgame-admin/snailValuables/${values.id}.png">
                                    </div>
                                    <span>${values.title}</span>
                                </li>`;
                                $('.goods-list-wrap ul').append(addHtml);
                            });
                            $('.tips-wrap').hide();
                        }
                    }
                },error: function() {
                    layer.msg("服务器请求失败", {time: 2000});
                },
                complete: function() {
                    layer.close(index);
                }
            })

        });
    },
    // wiki-贵重物品-筛选
    filtering: function() {
        rarity       = '';  // 品阶
        deviation    = '';  // 五围
        halo_effect  = '';  // 光环技能
        mosaic_skill = '';  // 镶嵌技能
        column       = '';  // 筛选参数1
        order        = '';  // 筛选参数2
        page         = '';  // 第几页
        url          = api + '/web/goods';  // 需要请求的地址

        // 第一次进入时候请求一次
        function wikiDataAjax(url) {
            $('.loading-wrap').fadeIn();
            $.ajax({
                url: url,
                type: "GET",
                data: {
                    rarity: rarity,
                    deviation: deviation,
                    halo_effect: halo_effect,
                    mosaic_skill: mosaic_skill,
                    column: column,
                    order: order,
                    page: page
                },
                xhrFields: {
                    withCredentials: true
                },
                success: function(json) {
                    if(json.code == 200) {
                        var next_page_url = json.data.data.next_page_url;   // 下一页的数据
                        // 渲染-所有贵重物品
                        // 橙色-1
                        // 蓝色-2
                        // 绿色-3
                        // 紫色-4
                        if(json.data.data.data.length !== 0) {
                            $.each(json.data.data.data, function(index, values) {
                                var addHtml = `<li class="li-color-0${values.colour}" 
                                titles="${values.title}"
                                colour="${values.colour}" 
                                art="${values.art}" 
                                culture="${values.culture}" 
                                describe="${values.describe}" 
                                deviation="${values.deviation}" 
                                faith="${values.faith}" 
                                get_type="${values.get_type}" 
                                halo_effect="${values.halo_effect}" 
                                id="${values.id}" 
                                mosaic_skill="${values.mosaic_skill}" 
                                popularity="${values.popularity}" 
                                quality="${values.quality}" 
                                rarity="${values.rarity}" 
                                rarity_order="${values.rarity_order}" 
                                technology="${values.technology}">
                                    <div>
                                        <img src="https://download4.qcplay.com/qcgame-admin/snailValuables/${values.id}.png">
                                    </div>
                                    <span>${values.title}</span>
                                </li>`;
                                $('.goods-list-wrap ul').append(addHtml);
                            });
                            // 如果下页有参数则显示更多按钮
                            next_page_url !== null ? $('.more-wrap').fadeIn().attr('data', next_page_url) : $('.more-wrap').hide();
                            $('.tips-wrap, .loading-wrap').hide();
                        } else {
                            layer.msg("未能找到相应贵重品", {time: 2000});
                            $('.tips-wrap').fadeIn();
                        }
                        $('.loading-wrap').hide();
                    }else {
                        $('.loading-wrap').fadeIn().html('服务器请求失败');
                    }

                },error: function() {
                    $('.loading-wrap').fadeIn().html('服务器请求失败');
                },
                complete: function() {
                    // layer.close(index);
                }
            })
        }
        wikiDataAjax(url);

        // 点击选择按钮
        $('.screen-wrap').on('click', 'li', function(event) {
            page = 1;           // 每次点击按钮的时候回到第一页
            var _this = $(this);
            _this.addClass('on').siblings().removeClass('on');            
            getLiData();        // 获取条件数据
            $('.goods-list-wrap ul').find('li').remove(); // 先清除一次再渲染
            wikiDataAjax(url);   // 选择条件数据后ajax请求            
        });

        // 关闭弹窗
        $('.screen-close').click(function(event) {
            $('.screen-popup').fadeOut();
            $('.bottom-nav li').removeClass('on');
        });


        // 点击更多查看下一页
        $('.more-wrap').click(function(event) {
            page = $(this).attr('data').split("?page=")[1];            
            getLiData();        // 获取条件数据
            wikiDataAjax(url)   // 选择条件数据后ajax请求
        });

        // 获取数据信息
        function getLiData() {
            rarity      = $('.grade').find('.on').attr('data');         // 品阶
            deviation   = $('.dimension').find('.on').attr('data');     // 五围
            halo_effect = $('.halo_effect').find('.on').attr('data');   // 光环技能
            mosaic_skill= $('.mosaic_skill').find('.on').attr('data');  // 镶嵌技能
            column      = $('.grade_array').find('.on').attr('column'); // 筛选参数1
            order       = $('.grade_array').find('.on').attr('order');  // 筛选参数2
        }

        // wiki-贵重物品-筛选-复位清除选项
        $('.reset-btn').click(function(event) {
            $('.goods-list-wrap ul').find('li').remove();
            $('.screen-wrap ul li:nth-child(1)').addClass('on').siblings().removeClass('on');
            rarity       = '';  // 品阶
            deviation    = '';  // 五围
            halo_effect  = '';  // 光环技能
            mosaic_skill = '';  // 镶嵌技能
            column       = '';  // 筛选参数1
            order        = '';  // 筛选参数2
            page         = '';  // 第几页
            url          = api + '/web/goods';  // 需要请求的地址
            wikiDataAjax(url);

            $('.screen-popup').fadeOut();

            $('.bottom-nav li').removeClass('on');
        });
    },
    // 尾部分享
    footShare: function() {
        // 开启分享二维码弹窗
        $('.follow-btn').click(function(event) {
            $('.follow-popup').fadeIn();
        });

        // 关闭分享弹窗
        $('.close-bg').click(function(event) {
            $('.follow-popup, .share-popup').fadeOut();
        });

        // 开启分享链接弹窗
        $('.share-btn').click(function(event) {
            $('.share-popup').fadeIn();
        });
    },
    // 阻止默认页面弹起影响触摸位置
    preventInput: function () {
        $("input").blur(function () {
            setTimeout(function () {
                var scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0;
                window.scrollTo(0, Math.max(scrollHeight - 1, 0));
                document.body.scrollTop = 0;
                document.documentElement.scrollTop = 0;
            }, 100);
        });
    },
    share: function() {
        $.ajax({
            url: api + "/wechat/jssdk",
            type: "POST",
            data: {
                uri: window.location.href,
            },
            success: function(json) {

                var ua = navigator.userAgent.toLowerCase();
                if (ua.match(/MicroMessenger/i) == "micromessenger") {
                    wx.config(json.data);
                    wx.ready(function() {
                        wx.updateAppMessageShareData({
                            title: '最强蜗牛', // 分享标题
                            desc: '大家都爱玩的沙雕手游', // 分享描述
                            link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                            imgUrl: 'https://static.qcplay.com/common/snail_icon.png', // 分享图标
                            success: function() {}
                        })

                        wx.updateTimelineShareData({
                            title: '最强蜗牛-大家都爱玩的沙雕手游', // 分享标题
                            link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                            imgUrl: 'https://static.qcplay.com/common/snail_icon.png', // 分享图标
                            success: function() {
                                // 设置成功
                            }
                        })
                    });
                    return;
                } else {
                    try {
                        setShareInfo({
                            title: '最强蜗牛', // 分享标题
                            summary: '大家都爱玩的沙雕手游', // 分享内容
                            pic: 'https://static.qcplay.com/common/snail_icon.png', // 分享图片
                            url: window.location.href, // 分享链接
                            // 微信权限验证配置信息，若不在微信传播，可忽略
                            WXconfig: {
                                swapTitleInWX: true, // 是否标题内容互换（仅朋友圈，因朋友圈内只显示标题）
                                appId: json.data.appId, // 公众号的唯一标识
                                timestamp: json.data.timestamp, // 生成签名的时间戳
                                nonceStr: json.data.nonceStr, // 生成签名的随机串
                                signature: json.data.signature // 签名
                            }
                        });
                    } catch (err) {}
                }
            }
        })
    },
    // 阿里云埋点
    countNum: function(data) {
        setTimeout(() => {
            try {
                __bl.sum(data);
            } catch (e) {
                console.log(e)
            }
        }, 500);
    }
}